
import React, { PropsWithChildren, useEffect, useState } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { CommandOptions } from './MitekTestConstants/MitekTestConstants';

import './MitekTest.css';

import FeedbackMap from '../../providers/MitekProvider/MitekFeedback/FeedbackKeys';

import DefaultSelfieFeedback from '../../providers/MitekProvider/MitekFeedback/SelfieFeedback';
import DefaultAutoCaptureHints from '../../providers/MitekProvider/MitekFeedback/AutoCaptureFeedback';
import DefaultGeneralHints from '../../providers/MitekProvider/MitekFeedback/GeneralHintFeedback';
import { IMitekCaptureConfiguration } from '../../providers/MitekProvider/MitekProvider';
import { InputBase } from 'component-library/index';

interface IMitekTestProps extends MappedComponentProperties {}

export const MitekTestEditConfig = {
    emptyLabel: 'Mitek - Test',
    isEmpty: (props: PropsWithChildren<IMitekTestProps>) => {
        return !props || !props.children;
    },
};

export const DefaultMitekConfiguration = {
    qualityPercent: 80, // 0-100 ( 70 lowest recommended)
};

const Config = (props: {type: string, id: string, min?: number, max?: number, step?: number, value?: number | string, checked?: true}): JSX.Element => {
    const [value, setValue] = useState(props.value ?? props.checked);
    return (
        <>
            <h4>{props.id}</h4>
            <input {...props} value={value !== true ? value : undefined} checked={value === true? value : undefined} onInput={(event: any) => {
                setValue(event.currentTarget.value as any); 
            }}/>
            <output id={`${props.id}Result`}>{value}</output>
        </>
    );
};

const licenses = {
    prod: 'eyJzaWduYXR1cmUiOiJTdGFkNDY3Kzl6MFQwaVVjam9KZXg4Y21JWEZPQXlwVDdMRXlCVjhKMXpDeXdFY2h3VmNtZ1A5L1EvMWQzQlFpNDRCUnAzZlE4R0xZQ2VyRlZXMHhzY1VibThWWU0vOVYxcFgzb01qL0l4SmxxU1ZUT2M4RVpMQkpTemZpYk05RzFmeWNxQ1BTTy9va2hrU1RzUkJkemZOUGE2Q01ZWllwU3N3UDcxcHlKTk9Fb29qZ1FIMjNtRW1XQ1MyblhOVDI5RUF6RUl3Ynk1dTdxUE9sd29vWllENDNHR1hrTzFLb044N08xVld1NlI5czV4MU9yR3daR3FHTk1QenJlK0t6dnJVdjBMV1lxc3l0NkNZSmZVSWc0V2J0UDQ3Vkt3MTIxbElza0xXdmQreHFDc0gwNHE5aXhMUlRzb1Y0UnBwOGNOSlloZllKZEIyUnF0a0ZRT1ZXQkE9PSIsInNpZ25lZCI6eyJleHBpcnkiOiIyMDI3LTAzLTMwIiwiZmVhdHVyZXMiOlsiYmFyY29kZSIsImlkIiwiZmFjZSJdLCJhcHBsaWNhdGlvbklkZW50aWZpZXIiOnsid2ViIjpbIiouY3JlZGl0b25lLmNvbSIsImNyZWRpdG9uZS5jb20iLCIqLmNyZWRpdG9uZWJhbmsuY29tIiwiY3JlZGl0b25lYmFuay5jb20iXX0sImdwbyI6IjE2ZCIsIm9yZ2FuaXphdGlvbiI6Ik1pdGVrIFN5c3RlbXMgSW5jLiIsInZlcnNpb24iOiIxLjAifSwiYmFyY29kZVdlYkxpY2Vuc2UiOiIyV2xmRTR1RFRNbWJ0anlORGwrUERPTS9lYkw4aEFxUDJvMFR0eUR4bmt0N1ZDbmY5Q2s4SjdpWVNvM29lNWx2NC9tU0x4YzI5V21vMzZBdXQvTmMvaVlCUm1GOEZsQzBsNmZmVXhWQWliMVh4Y3B0L2gzKzhvNnJwbGJXQmtIekpFTE8zc1FTVTgzc2dpa1plb1ZGRTh2OVgzT1AvaEpoeVZZaGVUaENFR1JVY3lsU1k1WUM4YzFUTTB0eWpWMHZGMVU2V1QrcHFRUGUzOTkySHhEdUl1Y1hhRnVxT2xjT3d2a1p1UWpaS2l1OUxLVHFGSUFQTEJOdVd6blhnNmVoRW5PZDJJZHNsRFVjSmpPb3p1YldmTEt5NlRKVkI5cGwyZHRBKzVENG91S1lRWFBOOUErRG5VcDgzWkhPMDllM29iQTUxYXFmNjQzUjRpZm9DU1pwWUxray90SkZxNFBnb3hNVFF3elZDSzJFQ1J4SjNhSjczZEJ1R01Qa2RWM2gzVGMwSWdXUnN6eXBIcVpvOElVMnpqZ2JzRnRWeHprTDRCVkZyZi94QzZIN0RrQkRFNGhiRFdqWTZDeVVLbjBpY3FWeWVNU2l2N2s2Ym9GaTZZenRpTUZMMHdTL1dQSDFmdjJRZDZqZElpOURkTnh3RG1acmlTaDZUN1IrTVRmViJ9',
    test: 'eyJzaWduYXR1cmUiOiIyQ0dueHlKMlA4RUZQRkMxS2w0TitMVjNPOWV6WjZsRWZmeGo4MTQzTUYyTE5zNXo4emN5V2FQY29rcEs0UUdhQkpldmRCZHRBS3RhTVAyMkNJcHhteG5KOXNiVjhXakxZYnBKWTkxUTk1eSsvZEhBdVZNMkJHT2ZDbWdjQ0ZBenVtdm43UmhDUW1xUjcyS0cxRnhqZGJGekRUTU9rYmhaaWtZTFprVDlHaTVTc3EvOTlab0I2V3JhbjI0OGc1NHlTOGU5N1pOSWYyL0F0LzA2aWpncU9VbFZ2VFVsMllsTFZJUVRMb0UwSlR0Sld4VXA3RDZjK21kN1FFZmZaZkloT3FRdW9Uc0VyWWJkZ2dDbHVLRnZ5M251dHZ2dVQwTkh3SGZPZWczUTVyVDJEK2svbjV2T0w4SkkzMllyZjZGeGNnVkZIS2ZqdzJ1QmV3M21TUUQ4YXc9PSIsInNpZ25lZCI6eyJleHBpcnkiOiIyMDMwLTEyLTMxIiwiZmVhdHVyZXMiOlsiYmFyY29kZSIsImRlcG9zaXQiLCJmYWNlIiwiZ2VuZXJpYyIsImlkIiwibmZjIiwib2RjIiwib2RlIiwidm9pY2UiXSwiYXBwbGljYXRpb25JZGVudGlmaWVyIjp7ImFuZHJvaWQiOlsiLSJdLCJpb3MiOlsiLSJdLCJ3ZWIiOlsiKi5taXRla2Nsb3VkLm5ldCJdfSwiZ3BvIjoiMTZkIiwib3JnYW5pemF0aW9uIjoiTWl0ZWsgU3lzdGVtcyBJbmMuIiwidmVyc2lvbiI6IjEuMCJ9fQ==',
};

const MitekTest = (): JSX.Element => {
    const [mitekReady, setMitekReady] = useState<boolean>(false);
    const [testHint, setTestHint] = useState<string>('');
    const [license, setLicense] = useState<string>(licenses.prod);
    const [mitekVersion, setMitekVersion] = useState<string>('Unknown');
    const [lastConfig, setLastConfig] = useState({});


    const getConfig = () => {
        const ids = [
            'qualityPercent',
            'disablePerpendicularCapture',
            'disableMirroring',
            'disableSmileDetection',
            'faceDetectionLevel',
            'hintMessageSize',
            'hintFrequencyMS',
            'hintAriaLive',
            'videoRecordingEnabled',
            'audioRecordingEnabled',
            'videoQuality',
            'useDeviceIdSignal',
        ];

        return Object.fromEntries(ids.map((value) : any[] => {
            const el = (document.getElementById(value) as HTMLInputElement);
            return [value, el.value || (el.checked ?? false)];
        }));
    };

    const handleOnClick = (event: any, config = getConfig()) => {
        setLastConfig(config);
        console.log('Launch Mitek Clicked: ', event);
        console.log('Mitek Config: ', config);
        if (testHint && testHint !== '') {
            window.mitekScienceSDK.on('CAMERA_DISPLAY_STARTED', () => {
                window.mitekScienceSDK.cmd('SHOW_HINT', {
                    options: {
                        hintText: testHint,
                        hintDuration: 2000,
                    },
                } as CommandOptions['SHOW_HINT']);
            });
        }

        function get<T>(id:string) {
            return (document.getElementById(id) as unknown as T); 
        }

        const documentType  = get<HTMLSelectElement>('integratorDocTypeInput').value;

        if (documentType) {
            window.mitekScienceSDK.on('FRAME_CAPTURE_RESULT', (result: any) => {
                if (result?.response?.imageData) {
                    const resultingImage = document.createElement('img');
                    resultingImage.src = result.response.imageData;
                    document.querySelector('#SuccessfulData')?.appendChild(resultingImage);
                }
            });

            window.mitekScienceSDK.on(
                'FRAME_PROCESSING_FEEDBACK',
                MitekHandleFeedbackCallback({
                    mode: 'AUTO_CAPTURE',
                    documentType: documentType as any,
                    mitekSDKPath: '/etc.clientlibs/cob-corp-acquisition/clientlibs/clientlib-mitek/resources'!,
                }));

            window.mitekScienceSDK.cmd('CAPTURE_AND_PROCESS_FRAME', {
                mitekSDKPath: '/etc.clientlibs/cob-corp-acquisition/clientlibs/clientlib-mitek/resources',
                mode: 'AUTO_CAPTURE',
                documentType,
                options: {
                    license,
                    ...config,
                },
            },
            );

        }
    };

    const handleOnClickSafeMode = (event: any) => {
        //auto-capture CAPTURE_AND_PROCESS_FRAME config object pulled from the Mitek example
        const autoCaptureOptions = {
            qualityPercent: 90,   // value between 60 to 100 for image quality 100 is no compression.
            hintFrequencyMS: 1000, // how long the hint message displays (in MS) / note: 2400 recommended for screen readers
            hintAriaLive: 0, //screen reader setting for hint updates value (0=off / 1=polite / 2=assertive)
            faceDetectionLevel: 1, // determines how strict face detection is (1=lenient, 2=moderate, 3=strict)
            hintMessageSize: 1,  // set the size of the hint message (1=small / 2=medium / 3=large)
            disableSmileDetection: false,  // disable smile detection
            //disableMirroring: false, //use this when you know a devices is reporting as a desktop and mirroring needs to be turned off for doc captures. Only use this if you already know its a desktop device.
            disablePerpendicularCapture: true, //perpendicular capture is a boolean value defaults to false if not provided. Forces document to follow device orientation.
            // videoContainerId: 'customdiv', // (optionally) embed the video in a custom HTML container
            videoRecordingEnabled: false, // (optionally) record the video session / returned as a dataURL
            audioRecordingEnabled: false, // (optionally) also record audio / only applies if videoRecordingEnabled = true)
            videoQuality: 30, // (optionally) value between 30 to 100 recommended (normalized bitrate of video / only applies if videoRecordingEnabled = true)
            videoRecordingMessage: 'Recording', // (optionally) override the default "Recording" message / Note: set to "" to disable icon and message
            redactMRZOptionalData: true, // (applicable only on certain NLD passports and Ids with 3 line mrz) it will redact optional data from mrz used for bsn
            // useDeviceIdSignal: true // toggles use of device signals feature
        };
        handleOnClick(event, autoCaptureOptions);
    };

    const abort = () => {
        window.mitekScienceSDK.cmd('SDK_STOP');
    };

    const handleTouch = (event: {
        targetTouches: {length: number},
        touches: {length: number},
        target: any,
        preventDefault: any,
    }) => {
        if (event.touches.length >= 3) {
            abort();
            event.preventDefault();
        }
    };

    const handleEscape = (event: any) => {
        if (event.key === 'Escape') {
            abort();
            event.preventDefault();
        }
    };
    
    const errorPrint = (err: any) => {
        let toReturn = '';

        for (const property in err) {
            if (typeof property === 'object') {
                toReturn += `<div>{<br>${errorPrint(err[property!])}<br>}</div>`;
            } else {
                toReturn += `<div>${property}: ${err[property]}</div><br>`;
            }
        }

        return toReturn;
    };

    const MitekHandleFeedbackCallback =
    (MitekConfig: IMitekCaptureConfiguration) =>
        (feedback: { key: keyof FeedbackMap }) => {
            if (MitekConfig.mode === 'AUTO_CAPTURE') {
                
                if (feedback.key in DefaultSelfieFeedback) {
                    if (typeof DefaultSelfieFeedback[feedback.key] === 'string') {
                        window.mitekScienceSDK.cmd('SHOW_HINT', DefaultSelfieFeedback[feedback.key]);
                    } else {
                        (DefaultSelfieFeedback[feedback.key] as Function)();
                    }
                    return;
                }
                if (feedback.key in DefaultAutoCaptureHints) {
                    (window as any).mitekScienceSDK.cmd(
                        'SHOW_HINT',
                        DefaultAutoCaptureHints[feedback.key],
                    );
                    return;
                }
            }

            if (feedback.key in DefaultGeneralHints) {
                (window as any).mitekScienceSDK.cmd(
                    'SHOW_HINT',
                    DefaultGeneralHints[feedback.key],
                );
                return;
            }
        };

    useEffect(() => {
        setMitekReady(true);
        function initSDKerror() {
            window.mitekScienceSDK.on('SDK_ERROR', (err: any) => {
                setMitekReady(false);
                console.error(err);
            });  

            fetch('/etc.clientlibs/cob-corp-acquisition/clientlibs/clientlib-mitek/resources/mitekMobileWeb.wasm').then(discarded => {
                console.log(discarded);
            });
            
            setMitekVersion(window.mitekScienceSDK.getVersion());
            window.addEventListener('touchstart', handleTouch);
            window.addEventListener('keydown', handleEscape);
        }

        if (window.mitekScienceSDK) {
            initSDKerror();
        } else {
            setTimeout(() => {
                if (!window.mitekScienceSDK) {
                    setMitekReady(false); 
                    console.error('Unable to load Mitek');     
                } else {
                    initSDKerror();
                }
            }, 100); 
        }

        // TODO: Figure out why this doesn't work?
        // console.log('Preloading Mitek');
        // window.mitekScienceSDK.cmd('COMPONENT_PRELOAD', {
        //     mitekSDKPath: props.mitekSdkPath!,
        //     preloadComponents: ['ALL'],
        //     options: {
        //         license,
        //     },
        // });

        return () => {
            window.removeEventListener('touchstart', handleTouch);
            window.removeEventListener('keydown', handleEscape);
        };
    }, []);

    return (<div style={{
        display: 'flex',
        padding: '1rem 5rem',
        justifyContent: 'center',
    }}>
        <div>
            <h1>Mitek <span style={{
                color: mitekReady ? 'Green' : 'Red',
            }}>{mitekReady ? 'Ready': 'Not Ready'}</span></h1>
            <div>
                <h2>Settings</h2>
                <h3>License</h3>
                <InputBase 
                    value={license}
                    setValue={setLicense} />
                <h3>Document Type</h3>
                <select id='integratorDocTypeInput' defaultValue='DL_FRONT'>
                    <option value='DL_FRONT' >DL FRONT</option>
                    <option value='PDF417_BARCODE'>PDF417 BARCODE</option>
                    <option value='QR_BARCODE'>QR BARCODE</option>
                    <option value='PASSPORT'>PASSPORT</option>
                    <option value='SELFIE'>SELFIE</option>
                    <option value='CHECK_FRONT'>CHECK FRONT</option>
                    <option value='CHECK_BACK'>CHECK BACK</option>
                    <option value='DOCUMENT'>DOCUMENT</option>
                </select>
                
                <Config type='range' id='qualityPercent' min={60} max={100} step={5} value={70}/>
                <Config type='checkbox' id='disablePerpendicularCapture'/>
                <Config type='checkbox' id='disableMirroring'/>
                <Config type='checkbox' id='disableSmileDetection'/>
                <Config type='range' id='faceDetectionLevel' min={1} max={3} value={1}/>
                <Config type='range' id='hintMessageSize' min={1} max={3} value={2}/>
                <Config type='number' id='hintFrequencyMS' min={0} step={10} value={1200} />
                <Config type='range' id='hintAriaLive' min={0} max={2} value={2}/>
                { /* Frame - Not sure what this is yet */}
                <Config type='checkbox' id='videoRecordingEnabled'/>
                <Config type='checkbox' id='audioRecordingEnabled'/>
                <Config type='range' id='videoQuality' min={60} max={100} step={5} value={70}/>
                
                {/* License is handled elsewhere */}

                <Config type='checkbox' id='useDeviceIdSignal'/>

            </div>
            <div>
                <h4>Test Hint</h4>
                <InputBase 
                    value={testHint}
                    setValue={setTestHint} />
            </div>
            <h4>Press Escape or Touch with 3 fingers to stop capturing</h4>
            <button 
                style={{
                    padding: '0.5rem 1rem',
                }}
                onClick={handleOnClick}
            >
                Launch Mitek
            </button>
            <button 
                style={{
                    marginLeft: '2rem',
                    padding: '0.5rem 1rem',
                }}
                onClick={handleOnClickSafeMode}
            >
                Launch Mitek with Default Props
            </button>
        </div>
        <div>
            {lastConfig && <div>
                <h2>Last Config</h2>
                {errorPrint(lastConfig)}
            </div>}
            <h2>Version</h2>
            <div>{mitekVersion}</div>
            <h2>Results</h2>
            <div>
                <h3>Success Data</h3>
                <div id='SuccessfulData'></div>
            </div>
            <div>
                <h3>Failed Data</h3>
                <div id='FailedData'></div>
            </div>
        </div>

    </div>);
};

export default MitekTest;